import { Fetch, schemas } from '@convergence/client';
import { useQuery } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function getLabs(fetch: Fetch) {
  return fetch('/labs', { method: 'get' }, schemas.LabsResponse);
}

export const useLabsQuery = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['labs'],
    retry: false,
    queryFn: async () => {
      const labs = await getLabs(fetch);
      return labs;
    },
    enabled
  });
};
